import React from 'react'

const MobileApp = () => {
    return (
        <iframe
            src="./browser/www/index.html"
            style={{ width: '100%', height: '100vh', border: 'none' }}
            title="External Content"
        />
    )
}

export default MobileApp
